import { render, staticRenderFns } from "./AddressConfirmationCard.vue?vue&type=template&id=b33afad0&scoped=true"
import script from "./AddressConfirmationCard.vue?vue&type=script&lang=ts"
export * from "./AddressConfirmationCard.vue?vue&type=script&lang=ts"
import style0 from "./AddressConfirmationCard.vue?vue&type=style&index=0&id=b33afad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33afad0",
  null
  
)

export default component.exports